"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _distributionProduct = require("@/api/distributionProduct");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'DistributionGoods',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        keywords: ''
      }
    };
  },
  created: function created() {
    this.load(1);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    normalizePage: function normalizePage(res) {
      var data = res && res.data !== undefined ? res.data : res;
      return data || {};
    },
    load: function load(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      (0, _distributionProduct.distributionProductListApi)(this.query).then(function (res) {
        var data = _this.normalizePage(res);
        _this.list = (data.list || data.records || []).map(function (row) {
          return _objectSpread(_objectSpread({}, row), {}, {
            productId: row.productId !== undefined ? row.productId : row.product_id,
            commissionOpen: Number(row.commissionOpen !== undefined ? row.commissionOpen : row.commission_open) === 1 ? 1 : 0
          });
        });
        _this.total = Number(data.total) || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    reset: function reset() {
      this.query = {
        page: 1,
        limit: 20,
        keywords: ''
      };
      this.load(1);
    },
    onSizeChange: function onSizeChange(limit) {
      this.query.limit = limit;
      this.load(1);
    },
    displayName: function displayName(row) {
      return row.productName || row.product_name || row.name || '未命名商品';
    },
    /** 原始售价取商品库的 origin_price（接入时的售价快照）；未接入商品库的商品显示 -。 */originPriceText: function originPriceText(row) {
      var raw = row.originPrice !== undefined && row.originPrice !== null ? row.originPrice : row.origin_price;
      return raw === undefined || raw === null || raw === '' ? '-' : raw;
    },
    /** 奖励类型：1-佣金(元) 2-积分 3-佣金比例(%)，其它值一律按「佣金(元)」处理 */rewardType: function rewardType(row, camelKey, snakeKey) {
      var raw = row[camelKey] !== undefined && row[camelKey] !== null ? row[camelKey] : row[snakeKey];
      var n = Number(raw);
      return n === 2 || n === 3 ? n : 1;
    },
    rewardValue: function rewardValue(row, camelKey, snakeKey) {
      var raw = row[camelKey] !== undefined && row[camelKey] !== null ? row[camelKey] : row[snakeKey];
      return Number(raw) || 0;
    },
    rewardText: function rewardText(row, camelPrefix, snakePrefix) {
      var type = this.rewardType(row, "".concat(camelPrefix, "Type"), "".concat(snakePrefix, "_type"));
      var value = this.rewardValue(row, "".concat(camelPrefix, "Value"), "".concat(snakePrefix, "_value"));
      if (!value) return '不发放';
      if (type === 2) return "".concat(value, " \u79EF\u5206");
      return type === 3 ? "".concat(value, "%") : "".concat(value, " \u5143");
    },
    /** 可抵扣购物券红包：0 显示「不可抵扣」，否则带上抵扣口径。 */couponDeductText: function couponDeductText(row) {
      var type = this.rewardType(row, 'couponDeductType', 'coupon_deduct_type');
      var value = this.rewardValue(row, 'couponDeductValue', 'coupon_deduct_value');
      if (!value) return '不可抵扣';
      return "".concat(value, " \u5143\uFF08").concat(type === 2 ? '超额抵扣' : '成本内抵扣', "\uFF09");
    },
    orderCouponText: function orderCouponText(row) {
      var value = this.rewardValue(row, 'orderCouponValue', 'order_coupon_value');
      return value ? "".concat(value, " \u5143") : '不赠送';
    },
    pointsText: function pointsText(row) {
      var type = this.rewardType(row, 'orderPointsType', 'order_points_type');
      var value = this.rewardValue(row, 'orderPointsValue', 'order_points_value');
      if (!value) return '不赠送';
      return type === 2 ? "".concat(value, " \u500D") : "".concat(value, " \u79EF\u5206");
    },
    /** 该配置限定了几个规格；返回 0 表示整品参加 */scopeCount: function scopeCount(row) {
      var scope = row && (row.attrValueIds || row.attr_value_ids);
      return scope ? String(scope).split(',').filter(function (v) {
        return v.trim();
      }).length : 0;
    },
    toggle: function toggle(row) {
      var _this2 = this;
      var open = Number(row.commissionOpen) === 1 ? 1 : 0;
      (0, _distributionProduct.distributionProductToggleApi)(row.id, open).then(function () {
        return _this2.$message.success(open ? '已启用淘客' : '已停用淘客');
      }).catch(function () {
        row.commissionOpen = open ? 0 : 1;
      });
    },
    remove: function remove(row) {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u5C06\u201C".concat(this.displayName(row), "\u201D\u9000\u51FA\u6DD8\u5BA2\u4E13\u533A\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _distributionProduct.distributionProductDeleteApi)(row.id);
      }).then(function () {
        _this3.$message.success('已退出淘客专区');
        _this3.load();
      }).catch(function () {});
    }
  }
};